import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule } from '@swimlane/ngx-charts';

// AngularFire2
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// Material
import { AppMaterialModule } from './app-material.module';

// Components
import { HomeComponent } from './components/home/home.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LogsComponent } from './components/logs/logs.component';
import { HeaderComponent } from './components/header/header.component';
import { BotSummaryComponent } from './components/bot-summary/bot-summary.component';
import { FillsComponent } from './components/fills/fills.component';

// services
import { SoundService } from './services/sound.service';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LogsComponent,
    HomeComponent,
    HeaderComponent,
    BotSummaryComponent,
    FillsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AppMaterialModule,
    BrowserAnimationsModule,
    NgxChartsModule
  ],
  providers: [
    SoundService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/app.module.ts